import React from "react";
import "./LoginPage.css";
import clmImage from "../assets/clm-image.webp";

const BASE_URL =
  window._env_?.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  "https://crclm-backend-dev.bravewave-24971d4f.eastus.azurecontainerapps.io/api";

function LoginPage({ onLogin }) {
  const handleLogin = () => {
    console.log("[LOG] handleLogin triggered, redirecting to:", `${BASE_URL}/login`);
    window.location.href = `${BASE_URL}/login`;
  };

  return (
    <div className="login-container">
      {/* Left side image */}
      <div className="login-left">
        <img src={clmImage} alt="CLM Illustration" className="left-image" />
      </div>

      {/* Right side login form */}
      <div className="login-right">
        <div className="login-form">
          <div className="brand-name">
            <span className="brand-contract">Contract</span>
            <span className="brand-lifecycle">Lifecycle Management</span>
          </div>
          <p className="quote-text">
            "From complexity to clarity, your contract journey begins here."
          </p>
          <button type="button" className="btn-microsoft" onClick={handleLogin}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
              alt="Microsoft"
            />
            Login with Microsoft
          </button>
          <p style={{ marginTop: "20px", textAlign: "center" }}>
            Not a CriticalRiver employee?{" "}
            <span
              onClick={() => window.location.href = "/external-login"}
              style={{ color: "#0078d4", cursor: "pointer", textDecoration: "underline" }}
            >
              Login here
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;